//? https://stenciljs.com/docs/stencil-store

import {createStore} from "@stencil/store";

type Todo = {
	userId: number;
	id: number;
	title: string;
	completed: boolean;
};

type Todos = {
	isLoading: boolean;
	hasChanges: boolean;
	data: Todo[];
};

const init = async (token: string) => {
	console.log("you should really use this token", token);
	await loadTodos().catch((error) => console.error("Error in loadAssets:", error));
};

const {state, onChange} = createStore<{
	todos: Todos;
	init: (token: string) => Promise<void>;
}>({
	todos: {isLoading: false, hasChanges: false, data: []},
	init,
});

const loadTodos = async () => {
	state.todos.isLoading = true;

	const response = await fetch("https://jsonplaceholder.typicode.com/todos");
	const data = (await response.json()) as Todo[];
	state.todos.data = data;

	state.todos.isLoading = false;

	console.debug("loadTodos", state.todos);
};

onChange("todos", (value) => console.log("todos changed", value));

export {state as clStore};
